import React, { Component } from 'react';
import { DropdownButton } from '../../components';
import s from './HostStyles.module.scss';

export default class DropdownButtonHost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mapNotePermissions: true,
            showDropdown: false,
        };
    }

    render() {
        return (
            <div className={s.editor} style={{ padding: '100px' }}>
                <DropdownButton
                    showDropdown={this.state.showDropdown}
                    mapNotePermissions={this.state.mapNotePermissions}
                    onShowDropdown={showDropdown => this.setState({ showDropdown })}
                    onNoteClick={() => {}}
                    onPointClick={() => {}}
                />
            </div>
        );
    }
}
